<!-- /Logo -->
<h4 class="mb-2">{{'Register' | translate}}</h4>
<!-- <p class="mb-4">{{'Register.Description' | translate}}</p> -->

<form (ngSubmit)="OnSubmit()" #loginForm="ngForm" autocomplete="off" novalidate>
    <input autocomplete="false" name="hidden" type="text" style="display:none;">
    <div class="mb-3 validation-alert">
        <label for="firstname" class="form-label">{{'FirstName' | translate}}</label>

        <input type="text" id="firstName" name="firstName" class="form-control text-start"
            [(ngModel)]="register.FirstName" #firstName="ngModel" required minlength="5" maxlength="400" 
            placeholder="{{'EnterFirstName' | translate}}" autofocus>

        <div class="alert alert-danger " *ngIf="firstName.invalid && firstName.dirty">
            <span class="help-block" *ngIf="firstName.errors?.['required']">
                {{ 'Required' | translate }}
            </span>
            <span class="help-block" *ngIf="firstName.errors?.['minlength']">
                {{ 'MinLenght' | translate : {'value':'5'} }}
            </span>
            <span class="help-block" *ngIf="firstName.errors?.['maxlength']">
                {{ 'MaxLenght' | translate : {'value':'20'} }}
            </span>
        </div>

    </div>
    <div class="mb-3 validation-alert">
        <label for="lastname" class="form-label">{{'LastName' | translate}}</label>

        <input type="text" id="lastname" name="lastname" class="form-control text-start" 
            [(ngModel)]="register.LastName" #lastname="ngModel" required  minlength="5" maxlength="400" dir="ltr"
            placeholder="{{'EnterLastName' | translate}}" autofocus >

        <div class="alert alert-danger " *ngIf="lastname.invalid && lastname.dirty">
            <span class="help-block" *ngIf="lastname.errors?.['required']">
                {{ 'Required' | translate }}
            </span>
            <span class="help-block" *ngIf="lastname.errors?.['minlength']">
                {{ 'MinLenght' | translate : {'value':'5'} }}
            </span>
            <span class="help-block" *ngIf="lastname.errors?.['maxlength']">
                {{ 'MaxLenght' | translate : {'value':'20'} }}
            </span>
        </div>
    </div>
    <div class="mb-3 validation-alert">
        <label for="username" class="form-label">{{'username' | translate}}</label>
        <input type="text" id="username" name="username" class="form-control text-start" 
            [(ngModel)]="register.EmailAddress" #emailAddress="ngModel" required  minlength="5" maxlength="400" dir="ltr"
            placeholder="{{'username' | translate}}" autofocus >

        <div class="alert alert-danger " *ngIf="emailAddress.invalid && emailAddress.dirty">
            <span class="help-block" *ngIf="emailAddress.errors?.['required']">
                {{ 'Required' | translate }}
            </span>
            <span class="help-block" *ngIf="emailAddress.errors?.['minlength']">
                {{ 'MinLenght' | translate : {'value':'5'} }}
            </span>
            <span class="help-block" *ngIf="emailAddress.errors?.['maxlength']">
                {{ 'MaxLenght' | translate : {'value':'20'} }}
            </span>
        </div>
    </div>
    <div class="mb-3 form-password-toggle validation-alert">
        <label class="form-label" for="password">{{'password' | translate}}</label>
        <div class="input-group input-group-merge">
            <input type="password" id="password" name="password" class="form-control text-start" 
            [(ngModel)]="register.Password" #password="ngModel" required  minlength="5" maxlength="400" dir="ltr"
            placeholder="{{'············' | translate}}" autofocus >
       
            <span class="input-group-text cursor-pointer"><i class="bx bx-hide"></i></span>
        </div>
        <div class="alert alert-danger " *ngIf="password.invalid && password.dirty">
            <span class="help-block" *ngIf="password.errors?.['required']">
                {{ 'Required' | translate }}
            </span>
            <span class="help-block" *ngIf="password.errors?.['minlength']">
                {{ 'MinLenght' | translate : {'value':'5'} }}
            </span>
            <span class="help-block" *ngIf="password.errors?.['maxlength']">
                {{ 'MaxLenght' | translate : {'value':'20'} }}
            </span>
        </div>
    </div>

    <div class="mb-3 validation-alert">
        <div class="form-check">
            <input type="checkbox" id="confirmPrivacy" name="confirmPrivacy" class="form-check-input" 
                [(ngModel)]="register.ConfirmPrivacy" #confirmPrivacy="ngModel" required  minlength="5" maxlength="400" dir="ltr"
                placeholder="{{'Agree' | translate}}" autofocus >

            <label class="form-check-label" for="terms-conditions">
                {{'Agree' | translate}}
                <a routerLinkActive="true" routerLink="/privacypolicy">{{'PrivacyPolicy' | translate}}</a>
            </label>
            <div class="alert alert-danger " *ngIf="confirmPrivacy.invalid && confirmPrivacy.dirty">
                <span class="help-block" *ngIf="confirmPrivacy.errors?.['required']">
                    {{ 'Required' | translate }}
                </span>
                <span class="help-block" *ngIf="confirmPrivacy.errors?.['minlength']">
                    {{ 'MinLenght' | translate : {'value':'5'} }}
                </span>
                <span class="help-block" *ngIf="confirmPrivacy.errors?.['maxlength']">
                    {{ 'MaxLenght' | translate : {'value':'20'} }}
                </span>
            </div>
        </div>
    </div>
    <button class="btn btn-primary d-grid w-100" [disabled]="!loginForm.form.valid">{{'Membership' |
        translate}}</button>
</form>

<app-loading-panel *ngIf="loading"></app-loading-panel>
<p class="text-center">
    <!-- <span>{{'HasAccount' | translate}}</span> -->
    <a routerLink="/login">
        <span>{{'HasAccount' | translate}}</span>
    </a>
</p>

<div class="divider my-4">
    <div class="divider-text">{{'Or' | translate}}</div>
</div>

<div class="d-flex justify-content-center">
    <a href="javascript:;" class="btn btn-icon btn-label-facebook me-3">
        <i class="tf-icons bx bxl-facebook"></i>
    </a>

    <a href="javascript:;" class="btn btn-icon btn-label-google-plus me-3" id="google-button">
        <i class="tf-icons bx bxl-google-plus"></i>
    </a>

    <a href="javascript:;" class="btn btn-icon btn-label-twitter">
        <i class="tf-icons bx bxl-twitter"></i>
    </a>
</div>